<template>
  <ul class="uk-nav-default uk-nav-parent-icon" uk-nav="multiple: true">
    <router-link v-for="mainNode in mainNodes" :key="mainNode.key" :to="'/' + mainNode.link" tag="li" active-class="uk-active">
      <a>{{ mainNode.label }}</a>
    </router-link>
    <li class="uk-parent" :class="{ 'uk-active': $route.path.startsWith('/' + node.link) }" v-for="node in parentNodes" :key="node.key">
      <a href="#">{{ node.label }}</a>
      <ul class="uk-nav-sub">
        <router-link v-for="childnode in node.children" :key="childnode.key" :to="'/' + childnode.link" tag="li" active-class="uk-active">
          <a>{{ childnode.label }}</a>
        </router-link>
      </ul>
    </li>
  </ul>
</template>

<script>
export default {
  props: ['label', 'nodes', 'link'],
  name: 'tree-menu',
  computed: {
    parentNodes () {
      if (!this.nodes) return false
      return this.nodes.filter(function (n) {
        return n.children
      })
    },
    mainNodes () {
      if (!this.nodes) return false
      return this.nodes.filter(function (n) {
        return !n.children
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/TreeMenu.vue